import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbNavModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { SimulationService } from '../../../services/simulation.service';
import { CompanyFeService } from '../../../services/companyfe.service';
import { SidebarService, SidebarData } from '../../../services/sidebar.service';
import { EnvironmentService } from '../../../services/environment.service';
import { UserAuthService } from '../../services/user-auth.service';

@Component({
  selector: 'adf-sidebar-new',
  standalone: true,
  imports: [CommonModule, NgbNavModule, NgbTooltip, TranslateModule, RouterModule],
  templateUrl: './sidebar-new.component.html',
  styleUrl: './sidebar-new.component.scss',
})
export class SidebarNewComponent implements OnInit {
  _simulationService = inject(SimulationService);
  _companyFeService = inject(CompanyFeService);
  _sidebarService = inject(SidebarService);
  _userAuthService = inject(UserAuthService);
  _environmentService = inject(EnvironmentService);

  version = this._environmentService.version;

  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);

  isOpen = true;
  expandedGroups: Record<string, boolean> = {};
  sidebarData$ = this._sidebarService.sidebarData$;
  isAdmin$ = this._userAuthService.isAdmin();
  canUserManagement$ = this._userAuthService.userHasPolicy(["Admin", "AdminRegional"]);
  canProject$ = this._userAuthService.userHasPolicy(["Standard", "Admin", "AdminRegional"]);
  isElectron = this._environmentService.isElectron();
  active = 1;
  route?: string;

  ngOnInit(): void {
    this._sidebarService.loadUserModules();

    this.router.events
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        filter((e) => e instanceof NavigationEnd),
        map((e) => e.urlAfterRedirects || e.url)
      )
      .subscribe((url) => {
        this.route = this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
        this._expandGroupForUrl(url, this._sidebarService.sidebarData$.value);
      });
  }

  toggleGroup(groupName: string) {
    this.expandedGroups[groupName] = !this.expandedGroups[groupName];
  }

  onToggle() {
    this.isOpen = !this.isOpen;
  }

  private _expandGroupForUrl(url: string, sidebarData: SidebarData) {
    for (const group of sidebarData.groups) {
      if (group.modules.some(mod => url.startsWith(mod.route))) {
        this.expandedGroups[group.name] = true;
        return;
      }
    }
  }
}
